
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree6a0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree6a0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7KmZ5", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $5a3ea87d56298164$export$6503ec6e8aabbaf; }, function (v) { return $5a3ea87d56298164$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $5a3ea87d56298164$export$f7ad0328861e2f03; }, function (v) { return $5a3ea87d56298164$export$f7ad0328861e2f03 = v; });
var $5a3ea87d56298164$export$6503ec6e8aabbaf;
var $5a3ea87d56298164$export$f7ad0328861e2f03;
"use strict";
var $5a3ea87d56298164$var$mapping = new Map();
function $5a3ea87d56298164$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$5a3ea87d56298164$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $5a3ea87d56298164$var$resolve(id) {
    var resolved = $5a3ea87d56298164$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$5a3ea87d56298164$export$6503ec6e8aabbaf = $5a3ea87d56298164$var$register;
$5a3ea87d56298164$export$f7ad0328861e2f03 = $5a3ea87d56298164$var$resolve;

});

var $7e02cfc763a2f2cf$exports = {};

(parcelRequire("7KmZ5")).register(new URL("", import.meta.url).toString(), JSON.parse('["kT2uN","index.b734768a.js","jTaE6","about.89be0347.js","1PDjh","sandbox-override.e6cbfe22.js","cVhiM","disclaimer.4c7ae5be.js","dbR85","custom.0d409aa5.js","87Z8c","aparam.0afa1cb5.js","hfTBP","gpmimergdaily.74e07d12.png","eg5fJ","GPM_3IMERGDF.data.7e1d30a1.js","5Y3xQ","arcgis.data.eece54b2.js","4o4me","east_coast_mar_20.3d5326cb.jpg","8kXCY","data-from-ghg.data.210a1e29.js","bZxFF","no2--dataset-cover.80478047.jpg","2HYIL","fire.data.4a553f40.js","dU8sT","nighttime-lights--dataset-cover.1cd08e26.jpg","cLk1p","nighttime-lights.data.168dcebe.js","afRNS","nighttime-lights--wuhan-bef-after.c0b1ed92.png","kRAiK","img-placeholder-3.4c5b2358.jpg","k5RdS","no2.data.cc15efd9.js","aiiuI","east_coast_mar_avg.6e8d4fc1.jpg","aEz8J","no2-south-america.f4744577.jpg","9loow","img-placeholder-4.728679b2.jpg","ag3UT","sandbox.data.4a05b026.js","gTJJL","air-quality-and-covid-19--story-cover.223fafff.jpg","fa399","air-quality-and-covid-19.stories.0defdac8.js","iprH3","external-link-example.stories.38787459.js","cGIep","img-placeholder-6.88847e66.jpg","4kBhn","internal-link-example.stories.4544b775.js","gYfok","life-of-water.stories.18d84642.js","1AGoU","mdx-content.ce464a9d.js","1xwPy","mdx-content.7c333d40.js","lgvBA","xlsx.32875ed8.js","fq8Ck","mdx-content.4b9060b0.js","kVMfm","mdx-content.2060dee7.js","lVQgr","mapbox-gl.e72d9938.js","cVjo9","marker-sdf.db41bce1.png","fEy5f","tour-comparison.b4c28c2d.gif","8uf9T","tour-analysis.af1a1ea4.gif","dz1O5","mdx-content.14584c73.css","aCIgA","catalog-content.d01790ae.js","k82uO","container.76f2ad04.js","3Jczy","mdx-content.b16c3324.js","gR8l2","catalog-content.a489f184.js","fsVT0","catalog-content.094ce1bc.css","7HKZg","mdx-content.cb449bcf.css","fnbHN","mdx-content.e9b8a949.js","kGMMb","mdx-content.2103fd2a.js","8AYYP","mdx-content.8764d844.css","37fzp","mdx-content.b94f5c0e.js","3YwG5","banner.54146571.js","hPXGp","site-alert.6ee72384.js","3PfWC","cookie-consent.00ec0e98.js","55C2M","cookie-consent.03c1f46b.js","6d7LV","cookie-consent.a5b7c2ab.css","6AvOJ","home.221ad833.js","gV0Aq","root-welcome--cover.eec7a022.jpg","8H48C","vp-01-illu.e16a91f2.png","8ziNX","vp-02-illu.23aae56a.png","3FUyX","vp-03-illu.2016f6ab.png","gUopo","user-enthusiasts.d134e85d.jpg","iENuT","user-scientists.0f1d1c3c.jpg","lh02Z","user-researcher.a227a485.jpg","fHAYv","about.f6512b9d.js","ccgle","development.8f1f1188.js","1FF4Q","container.12361c45.js","giyqV","container.a5dbe181.js","3Bv7d","single.ea887b1e.js","lNg97","container.b25da416.js","1rYVr","s-overview.15c68ece.js","bnok8","container.96fe84ab.js","7Zeat","container.ef5dc54d.css","1j1XR","sandbox.7f66bfdc.js","22dZJ","page.b60b33c1.js","fQ8Zj","img-placeholder-5.6262760b.jpg","gyXuT","page.90623331.js","ehX2l","chart.db9b4f6d.js","8JL4p","aq.4cb7c0a2.csv","kZt4I","two-column.ac7a3449.csv","w0SxJ","sample.57667550.json","69sAd","table.4a0f4d26.js","35GmZ","user-pages.ebfb487f.js"]'));


//# sourceMappingURL=index.runtime.e1da1b4c.js.map
